module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/thanks/2003_kuma_thankyou-a436b134789f5298b007466bec0259f9.png";